// extracted by mini-css-extract-plugin
module.exports = {"container":"Tab1_container__mMZRU","wrapper":"Tab1_wrapper__276qS","textWrapper":"Tab1_textWrapper__1uNpC","graphWrapper":"Tab1_graphWrapper__2RsvI","graph":"Tab1_graph__1BbJt"};